import { render, staticRenderFns } from "./ProductNutrition.vue?vue&type=template&id=8c8e8e4e&"
import script from "./ProductNutrition.vue?vue&type=script&lang=js&"
export * from "./ProductNutrition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports